<template>
  <div class="top">
    <div class="inner">
      <el-row>
        <el-col :span="16"
          ><p class="logo">{{ title }}</p></el-col
        >
        <el-col :span="4" :offset="4">
          <el-button type="success" class="loginR" @click="onBack">返回首页</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'backgroundTop',
  props: {
    title: String
  },
  methods: {
    onBack() {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.top {
  background-color: #086167;
  margin-bottom: 50px;
  .inner {
    @include autoInner();
    color: #fff;
    padding: 40px 0;
    p {
      font-size: 32px;
      color: #fff;
    }
  }
}
</style>
